<template>
  <div>
    <t-drawer :visible="show" :close-btn="true" @close="onCancel" size="1100px">
      <template #header>
        <div>{{ type === 'update' ? '页面布局分配角色' : '已分配角色' }}</div>
      </template>

      <div v-if="type === 'update'" style="margin-bottom: 12px; color: #000">
        请设置条件，筛选布局类型后，为各个角色分配可访问的布局页面
      </div>
      <div v-else style="margin-bottom: 12px; color: #000">
        您如果需要统一修改角色，可以点击
        <t-link theme="primary" style="color: #0052d9" @click="toObjectLayout">
          布局分配功能
          <icon-font name="link" />
        </t-link>
      </div>
      <t-form
        v-if="type === 'update'"
        layout="inline"
        :data="searchForm"
        ref="searchForm"
        style="margin-bottom: 16px"
      >
        <t-form-item label="" name="appid">
          <t-select
            label="相关应用:"
            v-model="searchForm.appid"
            :options="appOptions"
            :keys="{ label: 'name', value: 'id' }"
          ></t-select>
        </t-form-item>
        <t-form-item label="" name="platform">
          <t-select label="终端:" v-model="searchForm.platform" :options="PLATFORMS"></t-select>
        </t-form-item>

        <t-form-item label="" name="type" v-if="dimension !== 'usage'">
          <t-select label="布局类型:" v-model="searchForm.type" :options="LAYOUT_TYPES"></t-select>
        </t-form-item>

        <t-form-item label="" name="usage" v-if="dimension === 'usage'">
          <t-select
            label="用途场景:"
            placeholder="请选择"
            v-model="searchForm.usage"
            :keys="{ label: 'name', value: 'code' }"
            :options="allUsageList"
          ></t-select>
        </t-form-item>

        <t-form-item
          label=""
          name="objectName"
          v-if="!layoutInfo.objectName && dimension !== 'usage'"
        >
          <t-select
            label="元数据对象:"
            filterable
            placeholder="请选择"
            v-model="searchForm.objectName"
            :keys="{ label: 'display_name', value: 'name' }"
            :options="objectList"
            :loading="selecterLoading"
            @search="getObjectList"
          ></t-select>
        </t-form-item>
        <t-form-item label="" name="">
          <t-button theme="primary" class="form-button-margin" @click="initialize">
            <search-icon slot="icon" />
            搜索
          </t-button>

          <t-button variant="outline" @click="resetSearchForm">
            <refresh-icon slot="icon" />
            重置
          </t-button>
        </t-form-item>
      </t-form>
      <div v-if="type === 'update'">
        <div class="checked_Line">
          <span class="checkLine_word">布局分配角色</span>
          <span class="checkLine_box" v-if="dimension === 'record_type'">
            <el-checkbox v-model="checked_active" @change="handleChangeStatus">
              查看已分配{{ checkedCount }}项
            </el-checkbox>
          </span>
          <span class="checkLine_box" v-if="dimension === 'usage'">
            <el-checkbox v-model="checked_active" @change="handleUsageChecked">
              查看已分配{{ usageCheckedCount }}项
            </el-checkbox>
          </span>
        </div>
      </div>

      <t-tabs
        v-model="tabPlatform"
        v-if="type !== 'update' && layoutInfo.platform === MP_H5_PLATFORM"
        @change="platformTabChange"
      >
        <t-tab-panel :value="MP_PLATFORM" label="小程序"><p></p></t-tab-panel>
        <t-tab-panel :value="H5_PLATFORM" label="H5"><p></p></t-tab-panel>
      </t-tabs>
      <t-table
        ref="tableRef"
        :columns="columns"
        row-key="id"
        :data="tableList"
        bordered
        max-height="500px"
      ></t-table>

      <div class="layout-selecter" v-if="type === 'update' && dimension === 'record_type'">
        <span style="color: rgba(5, 118, 255, 1)">已选择{{ checkedCount }}</span>
        <span style="margin-left: 8px; margin-right: 8px">设置为</span>
        <t-select
          style="width: 232px"
          label=""
          v-model="layoutCode"
          :options="layoutList"
          :keys="{ label: 'name', value: 'code' }"
        ></t-select>
      </div>

      <template #footer class="drawer-footer">
        <div v-if="type === 'update'">
          <t-button variant="outline" @click="onCancel">取消</t-button>
          <t-button
            v-if="dimension === 'record_type'"
            @click="onConfirm"
            :disabled="confirmDisabled"
          >
            保存
          </t-button>
          <t-button
            v-if="dimension === 'usage'"
            @click="onConfirmUsage"
            :disabled="usageCheckedCount === 0"
          >
            保存
          </t-button>
        </div>
        <div v-else>
          <t-button @click="onClose">关闭</t-button>
        </div>
      </template>
    </t-drawer>
    <messageBox ref="messageBox" />
  </div>
</template>

<script>
import { DialogPlugin, MessagePlugin } from 'tdesign-vue';
import { mapGetters } from 'vuex';
import {
  MENU_PLATFORMS,
  LAYOUT_TYPES,
  MP_H5_PLATFORM,
  MP_PLATFORM,
  H5_PLATFORM,
} from '@/utils/constant';
import { SearchIcon, RefreshIcon, IconFont } from 'tdesign-icons-vue';
import { whereGql } from '@/graphql/util';
import { GetKvlist } from '@/api/kv.js';
import messageBox from '@/components/messageBox';

export default {
  components: {
    SearchIcon,
    RefreshIcon,
    IconFont,
    messageBox,
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    useSpecifyParamsOpen: {
      default: false,
      type: Boolean,
    },
    appOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      default: 'detail', // update - 修改， detail - 详情
      type: String,
    },
    // 用于详情页传入相关字段，查询
    layoutInfo: {
      type: Object,
      default() {
        return {
          appid: null,
          platform: null,
          type: '',
          objectName: '',
        };
      },
    },
    dimension: {
      default: 'record_type', // record_type - 用户/记录类型维度， usage - 用户/用途场景维度
      type: String,
    },
    viewAssignedRole: {
      default: false,
      type: Boolean,
    },
    // 从元数据布局进入，存在objectName
    // 从布局管理进入，不存在objectName
    // 如果不存在objectName，展示元数据选择框，取searchForm.objectName
    // 接口保持一致
  },
  data() {
    const filteredLAYOUT_TYPES = LAYOUT_TYPES.filter((item) => item.value !== 'search');
    return {
      searchForm: {
        page: 1,
        page_size: 10000,
        appid: null,
        platform: 1,
        type: '',
        objectName: '',
        keyword: '',
        usage: '',
      },
      roleList: [],
      allUsageList: [],
      recordTypeList: [],
      objectList: [],
      selecterLoading: false,
      selectEdObjectId: '',
      editableRowKeys: [],
      tableList: [],
      selectedList: [],
      layoutList: [],
      layoutCode: '',
      PLATFORMS: MENU_PLATFORMS,
      LAYOUT_TYPES: filteredLAYOUT_TYPES,
      tabPlatform: MP_PLATFORM,
      MP_H5_PLATFORM,
      MP_PLATFORM,
      H5_PLATFORM,
      checked_active: false,
      tempTableList: [],
      usageCheckedCount: 0,
      interfaceUsage: '',
      usageChangeObject: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        layoutManage: this.getElementList.includes('layout-manage'),
      };
    },

    columns() {
      let columns = [];
      const roleColumn = {
        width: 160,
        title: '角色',
        colKey: 'role_name',
        fixed: 'left',
      };
      if (this.dimension === 'record_type') {
        const rocordTypeColumns = this.recordTypeList.map((record) => {
          return {
            title: record.label,
            colKey: record.value,
            width: 160,
            cell: (h, { row }) => {
              const showDelete = row[record.value].layout_code;
              if (this.type === 'update') {
                return (
                  <t-checkbox
                    checked={row[record.value].checked}
                    data-row={row.id}
                    data-column={record.value}
                    onChange={() => {
                      row[record.value].checked = !row[record.value].checked;
                      this.updateSelectedList(
                        row[record.value].checked,
                        record.value,
                        row.role_code,
                        row[record.value],
                      );
                      {
                        /* this. */
                      }
                    }}
                  >
                    <span style={row[record.value].assigned ? 'color: var(--td-brand-color);' : ''}>
                      {row[record.value].layout_name}
                    </span>
                  </t-checkbox>
                );
              }
              if (showDelete && this.jurisdiction.layoutManage) {
                return (
                  <div>
                    {row[record.value].layout_name}
                    <el-button
                      type="text"
                      style="margin-left: 8px"
                      onClick={() =>
                        this.deleteRoleLayout(
                          row[record.value].layout_code,
                          row.role_code,
                          record.value,
                        )
                      }
                    >
                      取消分配
                    </el-button>
                  </div>
                );
              }
              return row[record.value].layout_name;
            },
          };
        });
        columns = rocordTypeColumns;
        console.log('------rocordTypeColumns------', rocordTypeColumns);
      } else {
        // 其他布局类型
        let usageColumns = [];
        if (this.type === 'update') {
          const usage_layout_prop = this.layoutList.map((item) => {
            return item.code;
          });
          usageColumns = this.layoutList.map((usage) => {
            return {
              title: usage.name,
              colKey: usage.code,
              cell: (h, { row }) => {
                return (
                  <div>
                    <t-checkbox
                      checked={row[usage.code]}
                      disabled={!row[usage.code] && usage_layout_prop.some((prop) => row[prop])}
                      onChange={(checked) => this.updateRowData(checked, row, usage.code)}
                    />
                  </div>
                  // 什么也没有选的场景 usage_layout_prop.some((prop) => row[prop]) 为false  disabled 为 false
                  // 有选的场景
                  // usage_layout_prop.some((prop) => row[prop])为 true ，
                  // 取决于row[usage.code]，选中的row[usage.code]为true，!row[usage.code] 为false disabled为false。可以取消
                );
              },
            };
          });
        } else {
          usageColumns = this.usageList.map((usage) => {
            return {
              title: usage.name,
              colKey: usage.code,
              cell: (h, { row }) => {
                const showDelete = row[usage.code].layout_code;
                if (this.type === 'update') {
                  return (
                    <t-checkbox
                      checked={row[usage.code].checked}
                      data-row={row.id}
                      data-column={usage.code}
                      onChange={() => {
                        row[usage.code].checked = !row[usage.code].checked;
                        this.updateSelectedListForUsage(
                          row[usage.code].checked,
                          usage.code,
                          row.role_code,
                          row[usage.code],
                        );
                        {
                          /* this. */
                        }
                      }}
                    >
                      <span style={row[usage.code].assigned ? 'color: var(--td-brand-color);' : ''}>
                        {row[usage.code].layout_name}
                      </span>
                    </t-checkbox>
                  );
                }
                if (showDelete && this.jurisdiction.layoutManage) {
                  return (
                    <div>
                      {row[usage.code].layout_name}
                      <el-button
                        type="text"
                        style="margin-left: 8px"
                        onClick={() =>
                          this.deleteRoleLayout(row[usage.code].layout_code, row.role_code)
                        }
                      >
                        取消分配
                      </el-button>
                    </div>
                  );
                }
                return row[usage.code].layout_name;
              },
            };
          });
        }
        columns = usageColumns;
      }
      return [roleColumn, ...columns];
    },
    checkedCount() {
      return this.selectedList.length;
    },
    confirmDisabled() {
      return this.selectedList.length === 0;
    },
    usageList() {
      if (this.type === 'update') {
        return this.allUsageList.filter((item) => item.code === this.searchForm.usage);
      }
      return this.allUsageList.filter((item) => item.code === this.layoutInfo.usage);
    },
  },
  watch: {
    layoutInfo(layoutInfo) {
      this.searchForm = {
        ...this.searchForm,
        appid: layoutInfo.appid,
        platform: layoutInfo.platform,
        type: layoutInfo.type,
        usage: layoutInfo.usage,
      };
    },
    show(show) {
      if (!show) {
        this.checked_active = false;
      }
      if (show && this.type === 'detail') {
        this.tabPlatform = MP_PLATFORM;
        this.initialize();
      }

      // 打开时处理默认选项
      if (show && this.type === 'update') {
        if (this.useSpecifyParamsOpen) {
          // 使用指定参数打开
          this.initialize();
        } else {
          this.searchForm.platform = 1; // 默认选中小程序
          const ngesAppItem = this.appOptions.find((item) => item.id === 2);
          if (ngesAppItem) {
            this.searchForm.appid = 2; // 默认选中nges
          }
        }
      }
    },
  },
  mounted() {
    if (this.layoutInfo.objectName || this.searchForm.objectName) {
      this.getRecordTypeList();
    }
    // this.getRoleList();
    this.getAllUsageList();
    this.getObjectList();
  },
  methods: {
    async updateRowData(checked, row, name) {
      // console.log('%c Line:417 🥛 checked, row, name', 'color:#e41a6a', checked, row, name);
      row[name] = !row[name];
      const data = {
        object_layout_type: '',
        object_code: '',
        object_record_type: '',
        usage: this.interfaceUsage,
        layout_code: '',
        role_code: row.role_code,
      };
      const key = this.interfaceUsage + row.role_code + name;
      // 发起http请求要用的数据
      if (checked) {
        data.layout_code = name;
        this.usageCheckedCount = this.usageCheckedCount + 1;
      } else {
        this.usageCheckedCount = this.usageCheckedCount - 1;
      }
      this.usageChangeObject[key] = data;
    },

    handleUsageChecked(val) {
      const usage_layout_prop = this.layoutList.map((item) => {
        return item.code;
      });
      if (val) {
        let list = this.tableList;
        list = list.filter((item) => {
          return usage_layout_prop.some((prop) => item[prop]);
        });
        this.tableList = list;
      } else {
        this.tableList = this.tempTableList;
      }
    },
    handleChangeStatus(val) {
      if (val) {
        let list = this.tableList;
        list = list.filter((item) => {
          return this.selectedList.some((itemB) => itemB.role_code === item.role_code);
        });
        this.tableList = list;
      } else {
        this.tableList = this.tempTableList;
      }
    },
    onClose() {
      this.$emit('close');
    },
    closeDrawer(isSuccess = false) {
      this.tableList = [];
      this.selectedList = [];
      this.layoutList = [];
      this.layoutCode = [];
      this.usageChangeObject = {};
      this.usageCheckedCount = 0;
      this.interfaceUsage = '';
      this.resetSearchForm();
      if (isSuccess) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    onCancel() {
      if (this.type === 'update') {
        const confirmDia = DialogPlugin.confirm({
          header: '提示',
          body: '所作更改将不会被保存，确认关闭?',
          confirmBtn: '确定',
          theme: 'warning',
          cancelBtn: '取消',
          onConfirm: () => {
            confirmDia.hide();
            this.closeDrawer();
          },
          onClose: () => {
            confirmDia.hide();
          },
        });
      } else {
        this.closeDrawer();
      }
    },
    async onConfirmUsage() {
      const data = Object.values(this.usageChangeObject);
      // console.log('%c Line:559 🍊 data', 'color:#6ec1c2', data);
      await this.$request({
        url: this.$api.setLayoutDistribute,
        data: {
          appid: this.searchForm.appid,
          platform: this.searchForm.platform,
          data,
        },
      });
      MessagePlugin('success', '分配成功');
      this.closeDrawer(true);
    },
    async onConfirm() {
      const data = this.selectedList.map((item) => {
        return {
          ...item,
          layout_code: this.layoutCode,
        };
      });
      console.log('------selectedList------', data);
      await this.$request({
        url: this.$api.setLayoutDistribute,
        data: {
          appid: this.searchForm.appid,
          platform: this.searchForm.platform,
          data,
        },
      });
      MessagePlugin('success', '分配成功');
      this.closeDrawer(true);
    },
    // 只展示10条，默认展示最上面10条，搜索之后根据搜索结果展示匹配的10条
    async getObjectList(search = '') {
      this.selecterLoading = true;
      const { objects } = await this.$request({
        url: this.$api.metaGetObjectList,
        data: {
          offset: 0,
          limit: 9999999,
          keyword: search,
          sort: '',
          object_name: '',
        },
      });
      this.objectList = objects.map((item) => {
        return {
          ...item,
          display_name: `${item.display_name} ${item.name}`,
        };
      });
      this.selecterLoading = false;
    },
    // getObjectId(val) {
    //   console.log('------getObjectId------', val);
    //   console.log('------objectList------', this.objectList);
    //   this.selectEdObjectId = this.objectList.find((item) => {
    //     return item.name === val.name;
    //   })?.id;
    //   console.log('---selectEdObjectId---', this.selectEdObjectId);
    // },
    async getObjectId(name) {
      const { objects } = await this.$request({
        url: this.$api.metaGetObjectList,
        data: {
          offset: 0,
          limit: 10,
          keyword: '',
          sort: '',
          object_name: name,
        },
      });
      const objectId = objects[0]?.id;
      return objectId || 0;
    },
    async toObjectLayout() {
      // 其他布局的场景处理
      if (this.dimension !== 'record_type') {
        const params = {
          platform: this.layoutInfo.platform <= 3 ? this.layoutInfo.platform : 3,
          appid: this.layoutInfo.appid,
          usage: this.layoutInfo.usage,
          objectName: '',
        };
        if (this.layoutInfo.platform === 4) {
          // 分配正确的平台
          params.platform = this.tabPlatform;
        }

        this.$emit('openUpdateUsage', params);
        return;
      }

      const id = await this.getObjectId(this.layoutInfo.objectName || this.searchForm.objectName);
      this.$router.push({
        name: 'metadata-layout',
        query: {
          id,
          name: this.layoutInfo.objectName || this.searchForm.objectName,
        },
      });
    },
    async getAllUsageList() {
      // 系统预设用途场景KV
      const presupposeKV = await GetKvlist({
        limit: 100000,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: 'layout_purpose_scene_list',
          },
        ]),
      });
      // 用户自定义用途场景KV
      const customer = await GetKvlist({
        limit: 100000,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: 'layout_purpose_scene_list_customer',
          },
        ]),
      });
      const [presupposeKVInfo] = presupposeKV?.kv?._data || [];
      const [customerKVInfo] = customer?.kv?._data || [];
      const presupposeList = JSON.parse(presupposeKVInfo?.value || '[]');
      const customerList = JSON.parse(customerKVInfo?.value || '[]');
      this.allUsageList = [...presupposeList, ...customerList];
    },
    async getRoleList() {
      const payload = {
        appid: this.layoutInfo.appid || this.searchForm.appid,
        keyword: '',
        page_size: 999999,
      };
      const { data } = await this.$request({
        url: this.$api.getRoleList,
        data: payload,
      });
      this.roleList = data;
    },
    async getRecordTypeList() {
      try {
        const { list } = await this.$request({
          url: this.$api.getObjectsByNames,
          data: {
            objects: [this.layoutInfo.objectName || this.searchForm.objectName],
          },
        });
        console.log(list);
        const object = list[0];
        const { fields } = object;
        const recordTypeField = fields.find((field) => field.name === 'record_type');
        const collator = new Intl.Collator('zh', { sensitivity: 'base' });
        this.recordTypeList = (recordTypeField?.select_one_option?.options || [])
          .map((item) => {
            return {
              ...item,
              enabled: !item.disabled,
            };
          })
          .sort((a, b) => {
            return collator.compare(a.label, b.label);
          });
        console.log('------recordTypeList------', this.recordTypeList);
        if (this.recordTypeList.length === 0) {
          this.recordTypeList = [
            {
              label: '默认记录类型',
              value: '',
            },
          ];
        }
        console.log('------recordTypeList------', this.recordTypeList);
      } catch (e) {
        console.log(e);
      }
      // this.recordTypeList = [];
    },
    async getLayoutList() {
      const { data } = await this.$request({
        url: this.$api.getLayoutList,
        data: {
          ...this.searchForm,
          objectName: undefined,
          object_code: this.layoutInfo.objectName || this.searchForm.objectName,
        },
      });
      this.layoutList = data;
    },
    async getLayoutDistribute() {
      let platform;
      // 如果是小程序+H5,则需要在查看详情时将其分配情况用tab隔开
      if (this.type !== 'update' && this.layoutInfo.platform === MP_H5_PLATFORM) {
        platform = this.tabPlatform || MP_PLATFORM;
      } else {
        platform = this.searchForm.platform || this.layoutInfo.platform;
      }
      const { data } = await this.$request({
        url: this.$api.getLayoutDistribute,
        data: {
          appid: this.layoutInfo.appid || this.searchForm.appid,
          platform,
          object_layout_type:
            this.dimension === 'record_type' ? this.layoutInfo.type || this.searchForm.type : '',
          object_code: this.layoutInfo.objectName || this.searchForm.objectName,
          usage: this.layoutInfo.usage ? this.layoutInfo.usage : this.searchForm.usage,
        },
      });
      this.layoutDistributeData = data;
      return data;
    },
    async initialize() {
      this.selectedList = [];
      if (this.dimension === 'record_type') {
        this.initializeByRecordType();
      } else {
        console.log('------initializeByUsage------');
        this.initializeByUsage();
      }
    },
    async initializeByRecordType() {
      if (this.type === 'update') {
        this.selectedList = [];
        const objectName = this.layoutInfo.objectName || this.searchForm.objectName;
        if (!objectName) {
          MessagePlugin('error', '请选择元数据对象');
          return;
        }
        if (!(this.searchForm.appid && this.searchForm.platform && this.searchForm.type)) {
          MessagePlugin('error', '请选择相关应用、终端和布局类型');
          return;
        }
      }
      const [distributeDetailInfo] = await Promise.all([
        this.getLayoutDistribute(),
        this.getLayoutList(),
        this.getRoleList(),
        this.getRecordTypeList(),
      ]);
      const distributeDetailInfoMap =
        this.getDistributeDetailInfoMapByRecordType(distributeDetailInfo);
      const showRoleList = this.viewAssignedRole
        ? this.roleList.filter((item) => this.layoutInfo.distribute_role_list.includes(item.code))
        : this.roleList;
      let list = showRoleList.map((role, idx) => {
        const listItem = {
          id: idx,
          role_name: role.name,
          role_code: role.code,
        };
        this.recordTypeList.forEach((recordType) => {
          listItem[recordType.value] = {
            layout_code:
              distributeDetailInfoMap?.get(role.code)?.get(recordType.value)?.layout_code || '',
            layout_name:
              distributeDetailInfoMap?.get(role.code)?.get(recordType.value)?.layout_name ||
              '--暂无布局--',
            layout_type:
              distributeDetailInfoMap?.get(role.code)?.get(recordType.value)?.layout_type ||
              this.searchForm.type,
            checked: false,
          };
          if (
            this.type === 'update' &&
            !['', '--暂无布局--'].includes(listItem[recordType.value].layout_name)
          ) {
            // listItem[recordType.value].checked = true;
            // this.selectedList.push({
            //   object_layout_type: this.searchForm.type,
            //   object_code: this.layoutInfo.objectName || this.searchForm.objectName,
            //   object_record_type: recordType.value,
            //   usage: '',
            //   layout_code: '',
            //   role_code: listItem.role_code,
            // });
            listItem[recordType.value].assigned = 1;
          }
        });
        return listItem;
      });
      if (this.type === 'detail') {
        // 多列的处理
        const keys = [];
        this.recordTypeList.forEach((recordType) => {
          keys.push(recordType.value);
        });
        list.forEach((item) => {
          item.show = true;
          if (keys.every((key) => item[key].layout_code === '')) {
            item.show = false;
          }
        });
        list = list.filter((item) => item.show);
      }
      this.tableList = list;
      this.tempTableList = this.tableList;
      this.checked_active = false;
    },

    async initializeByUsage() {
      this.usageChangeObject = {};
      this.usageCheckedCount = 0;
      console.log('------initializeByUsage------');
      if (!(this.searchForm.appid && this.searchForm.platform && this.searchForm.usage)) {
        MessagePlugin('error', '请选择相关应用、终端和用途场景');
        return;
      }
      const [distributeDetailInfo] = await Promise.all([
        this.getLayoutDistribute(),
        this.getLayoutList(),
        this.getRoleList(),
      ]);
      console.log('---distributeDetailInfo---', distributeDetailInfo);
      this.usageCheckedCount = distributeDetailInfo.length || 0;
      const distributeDetailInfoMap = this.getDistributeDetailInfoMapForUsage(distributeDetailInfo);
      console.log('---distributeDetailInfoMap---', distributeDetailInfoMap);
      const showRoleList = this.viewAssignedRole
        ? this.roleList.filter((item) => this.layoutInfo.distribute_role_list.includes(item.code))
        : this.roleList;
      let list = [];
      this.interfaceUsage = this.usageList[0].code;
      if (this.type === 'update') {
        this.selectedList = [];
        // usage_layout_prop 其他布局的列属性
        const usage_layout_prop = this.layoutList.map((item) => {
          return item.code;
        });

        list = showRoleList.map((role, idx) => {
          const listItem = {
            id: idx,
            role_name: role.name,
            role_code: role.code,
            key: role.code,
          };

          usage_layout_prop.forEach((item) => {
            listItem[item] = false;
          });
          const currentList = distributeDetailInfo.filter(
            (distributeItem) => listItem.role_code === distributeItem.role_code,
          );

          currentList.forEach((chooseItem) => {
            listItem[chooseItem.layout_code] = true;
          });
          return listItem;
        });
      } else {
        list = showRoleList.map((role, idx) => {
          const listItem = {
            id: idx,
            role_name: role.name,
            role_code: role.code,
          };
          console.log('---usageList---', this.usageList);
          this.usageList.forEach((usage) => {
            listItem[usage.code] = {
              layout_code:
                distributeDetailInfoMap?.get(role.code)?.get(usage.code)?.layout_code || '',
              layout_name:
                distributeDetailInfoMap?.get(role.code)?.get(usage.code)?.layout_name ||
                '--暂无布局--',
              layout_type:
                distributeDetailInfoMap?.get(role.code)?.get(usage.code)?.layout_type ||
                this.searchForm.type,
              checked: false,
            };
            if (
              this.type === 'update' &&
              !['', '--暂无布局--'].includes(listItem[usage.code].layout_name)
            ) {
              // listItem[usage.code].checked = true;
              // this.selectedList.push({
              //   object_layout_type: '',
              //   object_code: '',
              //   object_record_type: '',
              //   usage: usage.code,
              //   layout_code: '',
              //   role_code: listItem.role_code,
              // });
              listItem[usage.code].assigned = 1;
            }
          });
          return listItem;
        });
      }
      if (this.type === 'detail') {
        const keys = [];
        this.usageList.forEach((item) => {
          keys.push(item.code);
        });
        list.forEach((item) => {
          item.show = true;
          if (keys.every((key) => item[key].layout_code === '')) {
            item.show = false;
          }
        });
        list = list.filter((item) => item.show);
      }
      this.tableList = list;
      this.tempTableList = this.tableList;
      this.checked_active = false;
    },
    // 根据 role_code - object_record_type - layout的对应关系生成一个二维Map
    getDistributeDetailInfoMapByRecordType(list) {
      const distributeDetailInfoMap = new Map();
      list.forEach((item) => {
        const {
          layout_code,
          role_code,
          layout_name,
          object_record_type: record_type,
          object_layout_type: layout_type,
        } = item;
        if (!distributeDetailInfoMap.has(role_code)) {
          distributeDetailInfoMap.set(role_code, new Map());
        }
        const recordTypeMap = distributeDetailInfoMap.get(role_code);
        recordTypeMap.set(record_type, {
          layout_code,
          layout_name,
          layout_type,
        });
      });
      return distributeDetailInfoMap;
    },
    // // 根据 role_code - usage - layout的对应关系生成一个二维Map
    getDistributeDetailInfoMapForUsage(list) {
      const distributeDetailInfoMap = new Map();
      list.forEach((item) => {
        const {
          layout_code,
          role_code,
          layout_name,
          usage,
          object_layout_type: layout_type,
        } = item;
        if (!distributeDetailInfoMap.has(role_code)) {
          distributeDetailInfoMap.set(role_code, new Map());
        }
        const usageMap = distributeDetailInfoMap.get(role_code);
        usageMap.set(usage, {
          layout_code,
          layout_name,
          layout_type,
        });
      });
      return distributeDetailInfoMap;
    },
    resetSearchForm() {
      this.$refs.searchForm?.reset();
    },
    // 更新被选中的item。
    updateSelectedList(val, object_record_type, role_code) {
      const idx = this.selectedList.findIndex((item) => {
        return item.role_code === role_code && item.object_record_type === object_record_type;
      });
      // val = true 勾选， val = false 取消勾选
      if (val) {
        if (idx >= -1) {
          this.selectedList.push({
            object_layout_type: this.searchForm.type,
            object_code: this.layoutInfo.objectName || this.searchForm.objectName,
            object_record_type,
            usage: '',
            layout_code: '',
            role_code,
          });
        }
      } else {
        if (idx >= -1) {
          this.selectedList.splice(idx, 1);
        }
      }
    },
    updateSelectedListForUsage(val, usage, role_code) {
      const idx = this.selectedList.findIndex((item) => {
        return item.role_code === role_code && item.usage === usage;
      });
      // val = true 勾选， val = false 取消勾选
      if (val) {
        if (idx >= -1) {
          this.selectedList.push({
            object_layout_type: '',
            object_code: '',
            object_record_type: '',
            usage,
            layout_code: '',
            role_code,
          });
        }
      } else {
        if (idx >= -1) {
          this.selectedList.splice(idx, 1);
        }
      }
    },
    deleteRoleLayout(code, role, thirdCheckParams) {
      let aimIndex = -1;

      if (this.dimension === 'record_type') {
        aimIndex = this.layoutDistributeData.findIndex((i) => {
          return (
            i.layout_code === code &&
            i.role_code === role &&
            i.object_record_type === thirdCheckParams
          );
        });
      } else {
        aimIndex = this.layoutDistributeData.findIndex((i) => {
          return i.layout_code === code && i.role_code === role;
        });
      }
      if (aimIndex === -1) return;
      this.$refs.messageBox.show({
        title: `是否确认取消将当前布局分配给「${this.layoutDistributeData[aimIndex].role_name}」`,
        noBody: true,
        titleIconType: 'warning',
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.layoutDistributeData[aimIndex].layout_code = '';
          const data = {
            appid: this.layoutInfo.appid,
            platform:
              this.layoutInfo.platform === MP_H5_PLATFORM
                ? this.tabPlatform
                : this.layoutInfo.platform,
            data: this.layoutDistributeData,
          };
          this.$request({
            url: this.$api.setLayoutDistribute,
            data,
          }).then(() => {
            this.$message.success('取消分配成功');
            this.initialize();
            this.$emit('update');
            this.$refs.messageBox.close();
          });
        },
      });
    },
    platformTabChange() {
      this.initialize();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/tdesign/form.scss';
@import '@/styles/tdesign/table.scss';
::v-deep .t-drawer__footer {
  display: flex;
  justify-content: flex-end;
}
.layout-selecter {
  margin-top: 16px;
  height: 32px;
  line-height: 32px;
  display: flex;
}
.checked_Line {
  min-height: var(--td-comp-size-xxxl);
  padding: 0 var(--td-comp-paddingLR-l);
  font: var(--td-font-title-medium);
  color: var(--td-text-color-primary);
  border-bottom: 1px solid var(--td-border-level-1-color);
  border-radius: var(--td-radius-small) var(--td-radius-small) 0 0;
}
.checkLine_box {
  float: right;
  padding: 0 12px;
}
</style>
